import { GlobalAccount, GUID, NoteView, OpportunityView, TaskView } from '@ndvr/customer-api';

import { HouseholdNoteFormType } from '../household/HouseholdNotes/HouseholdNoteForm';
import { OpportunityLink } from '../opportunities/useSubmitOpportunityForm';
import { OpportunityFormType } from '../opportunities/widgets/OpportunityForm';
import { TaskFormType } from '../tasks/widgets/TaskForm';

export type DockState = {
    activeId: string | null;
    items: DockItem[];
    isMaximized: boolean;
};

export type DockItem =
    | CreateNoteDockItem
    | UpdateNoteDockItem
    | CreateTaskDockItem
    | UpdateTaskDockItem
    | CreateOpportunityDockItem
    | UpdateOpportunityDockItem;

export enum DockItemType {
    CREATE_NOTE = 'CREATE_NOTE',
    UPDATE_NOTE = 'UPDATE_NOTE',
    CREATE_TASK = 'CREATE_TASK',
    UPDATE_TASK = 'UPDATE_TASK',
    CREATE_OPPORTUNITY = 'CREATE_OPPORTUNITY',
    UPDATE_OPPORTUNITY = 'UPDATE_OPPORTUNITY',
}

type IDockItem<SType extends DockItemType, T = never> = {
    id: string;
    type: SType;
    openedAt: string;
    data: T;
};

export type CreateNoteDockItem = IDockItem<
    DockItemType.CREATE_NOTE,
    HouseholdNoteFormType & {
        showHouseholdInput: boolean;
        globalAccountGUID?: GUID<GlobalAccount>;
        eventGUID?: string;
    }
>;

export type UpdateNoteDockItem = IDockItem<
    DockItemType.UPDATE_NOTE,
    HouseholdNoteFormType & {
        noteGUID: GUID<NoteView>;
        globalAccountGUID?: GUID<GlobalAccount>;
        viewMode?: 'edit' | 'view';
    }
>;

export type CreateTaskDockItem = IDockItem<
    DockItemType.CREATE_TASK,
    TaskFormType & {
        showHouseholdInput: boolean;
        globalAccountGUID?: GUID<GlobalAccount>;
        eventGUID?: string;
        actionItemGUID?: string;
        noteGUID?: GUID<NoteView>;
    }
>;

export type UpdateTaskDockItem = IDockItem<
    DockItemType.UPDATE_TASK,
    TaskFormType & {
        taskGUID: GUID<TaskView>;
        globalAccountGUID?: GUID<GlobalAccount>;
        commentDraft: string;
        viewMode: 'edit' | 'view';
    }
>;

export type CreateOpportunityDockItem = IDockItem<
    DockItemType.CREATE_OPPORTUNITY,
    OpportunityFormType & {
        showProspectInput: boolean;
        prospectGUID?: GUID<GlobalAccount>;
        link?: OpportunityLink;
    }
>;

export type UpdateOpportunityDockItem = IDockItem<
    DockItemType.UPDATE_OPPORTUNITY,
    OpportunityFormType & {
        opportunityGUID: GUID<OpportunityView>;
        prospectGUID: GUID<GlobalAccount>;
    }
>;
